import { toast } from "react-toastify";
import type { AxiosError } from "axios";
import api from "./api/api";

const FornecedoresEmpresaServices = {
  getListagemFornecedores: async (
    page: number,
    perPage: number,
    search?: string,
    tipo?: number,
    municipio?: string,
    uf?: string,
    responsavel_id?: any,
    tipo_servico?: string,
  ) => {
    try {
      const params = new URLSearchParams({
        page: String(page),
        perPage: String(perPage),
      });

      if (search) {
        params.append("s", search);
      }
      if (tipo) {
        params.append("tipo", String(tipo));
      }
      if (municipio) {
        params.append("municipio", municipio);
      }
      if (uf) {
        params.append("uf", uf);
      }
      if (responsavel_id) {
        params.append("responsavel_id", String(responsavel_id));
      }
      if (tipo_servico) {
        params.append("tipo_servico", tipo_servico);
      }

      const res = await api.get(`/fornecedores-empresa?${params.toString()}`);
      return res;
    } catch (error: unknown) {
      return (error as AxiosError).response;
    }
  },
  listClientesPagination: async (
    page: any,
    perPage: any,
    findByName: string = "",
    tipoCliente?: any,
  ) => {
    try {
      const res = await api.get(
        `/clientes?page=${page}&perPage=${perPage}&s=${findByName}${
          tipoCliente ? `&type_cliente=${tipoCliente}` : ""
        }`,
      );
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getAgencyTipos: async () => {
    try {
      const res = await api.get(`/agency-tipos`);
      return res;
    } catch (error: any) {
      toast.error(error.response.data.msg);
      return error.response;
    }
  },
  cadastrarFornecedor: async (payload: any) => {
    try {
      const res = await api.post(`/fornecedores-empresa`, payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getFornecedor: async (id: number) => {
    try {
      return await api.get(`/fornecedores-empresa/${id}`);
    } catch (error: unknown) {
      return (error as AxiosError).response;
    }
  },
  editarFornecedor: async (payload: any, id: any) => {
    try {
      const res = await api.put(`/fornecedores-empresa/${id}`, payload, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return res;
    } catch (error: any) {
      toast.error(
        error.response?.data?.error ||
          error.response?.data?.msg ||
          "Erro ao editar fornecedor",
      );
      return error.response;
    }
  },
  deleteFornecedor: async (id: any) => {
    try {
      const res = await api.delete(`/fornecedores-empresa/${id}`);
      toast.success("Fornecedor removido com sucesso");
      return res;
    } catch (error: any) {
      toast.error(
        error.response?.data?.error ||
          error.response?.data?.msg ||
          "Erro ao remover fornecedor",
      );
      return error.response;
    }
  },
  getContatosBusca: async (
    page: any,
    perPage: any,
    busca?: any,
    fornecedor_id?: any,
  ) => {
    try {
      const params = new URLSearchParams();

      params.append("page", page);
      params.append("perPage", perPage);
      if (busca) params.append("s", busca);
      if (fornecedor_id) params.append("fornecedor_empresa_id", fornecedor_id);
      const res = await api.get(`/users?${params.toString()}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
};

export default FornecedoresEmpresaServices;
